import { queryOptions } from '@tanstack/react-query';
import type { ImportQueueListQuery, SourceMessageDto, SourceMessageListResponse } from '@upme/contracts';
import { api } from '../../app/api-client';

export const importQueueKey = ['admin', 'import-queue'] as const;

export type ImportQueueListFilters = Partial<Omit<ImportQueueListQuery, 'limit'>> & { limit?: number };

function buildSearchParams(filters: ImportQueueListFilters): URLSearchParams {
  const params = new URLSearchParams();
  for (const [k, v] of Object.entries(filters)) {
    if (v === undefined || v === null || v === '') continue;
    params.set(k, String(v));
  }
  return params;
}

export const listImportQueueOptions = (filters: ImportQueueListFilters = {}) =>
  queryOptions({
    queryKey: [...importQueueKey, 'list', filters] as const,
    queryFn: () =>
      api
        .get('admin/import-queue', { searchParams: buildSearchParams(filters) })
        .json<SourceMessageListResponse>(),
    staleTime: 5_000,
  });

export const importQueueItemByIdOptions = (id: string) =>
  queryOptions({
    queryKey: [...importQueueKey, id] as const,
    queryFn: () => api.get(`admin/import-queue/${id}`).json<SourceMessageDto>(),
  });
